export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/glass.f9141870.svg","height":175,"width":175,"blurWidth":0,"blurHeight":0};